import { initEditOffer } from '@pages-old/edit-offer/main';
import { translations } from '@tools/translations/translations';
import { isFloat } from 'validator';
import { createApp } from 'vue';
import VueDatePicker from '@vuepic/vue-datepicker';
import {
  parseStringToDate,
  parseDateToString,
} from '@tools/date';
import TwigFormValidator from '@tools/twig-form/validator';

/**
 * Init step offer details
 */
export default function (container) {
  let initContractType = null;
  let initCurrentDate = null;
  const availabilityDateElement = document.querySelector(
    '#setup_data_availabilityDate',
  );
  if (availabilityDateElement) {
    const availability = parseStringToDate(availabilityDateElement.value);
    const now = new Date();
    if (availability !== null && availability < now) {
      initCurrentDate = now;
      availabilityDateElement.value = parseDateToString(now);
    }
    if (availability !== null) {
      initCurrentDate = availability;
    }
  }
  const initContractTypeElement = document.getElementById(
    'setup_data_contractType',
  );
  if (initContractTypeElement) {
    initContractType = initContractTypeElement.options[initContractTypeElement.selectedIndex]
      .value; // eslint-disable-line max-len
  }

  const component = {
    delimiters: [ '${', '}' ],
    // Init datepicker component. All attributes setted into SetupDetailsType.php
    components: {
      datepicker: VueDatePicker,
    },
    data() {
      return {
        date: {
          value: initCurrentDate,
          format: 'dd/MM/yyyy',
          min: new Date(),
        },
        contractType: initContractType,
        setupEntryFees: {
          max: 100000000,
        },
      };
    },
    mounted() {
      this.initDisplay();
      initEditOffer();
    },
    methods: {
      validateForm() {
        const validator = new TwigFormValidator({
          formSelector: `${container} form`,
          rules: {
            'setup[data][entryFees]': [
              'required',
              'float',
              (value) => isFloat(value, { max: this.setupEntryFees.max }),
            ],
            'setup[data][eventTypes][]': 'required',
            'setup[data][availabilityDate]': 'required',
            'setup[data][price]': 'required',
            'setup[data][deposit]': 'required',
            'setup[data][contractType]': 'required',
            'setup[data][noticePeriod]': 'required',
            'setup[data][maxDuration]': 'required',
            'setup[data][light]': 'required',
            'setup[data][floor]': 'required',
            'setup[data][elevator]': 'required',
            'setup[data][spaceType]': 'required',
            'setup[data][style]': 'required',
          },
          messages: {
            'setup[data][entryFees]': [
              'required',
              'required',
              translations.validators[
                'form.validation.error.less_or_equal.number'
              ].replace(
                '{{ compared_value }}',
                this.setupEntryFees.max.toLocaleString('fr-FR'),
              ),
            ],
            'setup[data][availabilityDate]': () => {
              let labelElem = document.getElementById('setup_data_availabilityDate-error');
              if (labelElem) {
                labelElem.remove();
              }
              const datePicker = document.querySelector('.availability-date-picker .vdp__input');
              const parent = datePicker.parentNode.parentNode;

              // Add label error after the datepicker
              const errorMessage = translations.validators['form.twig.validator.required'];
              parent.insertAdjacentHTML('beforeend', `<label id="setup_data_availabilityDate-error" class="error">${errorMessage}</label>`);
              labelElem = document.getElementById('setup_data_availabilityDate-error');

              if (labelElem) {
                labelElem.classList.remove('error');
                labelElem.classList.add('error--back');

                // Add class to the datepicker div container
                parent.classList.add('error', 'active', 'input-text');
              }
            },
          },
        });
        validator.init();
      },
      /**
       * datepickerValueChanged
       * @param date
       * @description Trigger when a date is picked. Set the input hidden with proper value.
       */
      datepickerValueChanged(date) {
        if (!date) {
          return;
        }
        this.date.value = date;
        document.querySelector(
          '#setup_data_availabilityDate',
        ).value = parseDateToString(date);
        if (document.getElementById('setup_data_availabilityDate-error')) {
          document.getElementById('setup_data_availabilityDate-error').style.display = 'none';
          document.querySelector('.availability-date-picker .dp__main .input-text').classList.remove('error');
        }
      },
      /**
       * initDisplay
       * @description initial display rules for google search and related new address form
       */
      initDisplay() {
        this.validateForm();
      },
    },
  };

  return createApp(component).mount(container);
}
